import styled from 'styled-components';

export const DraftContainer = styled.div<{ $modernized?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${(props) =>
    props.$modernized
      ? props.theme.atlas.semantic.color.surface.default
      : props.theme.atlas.semantic.color.surface.variant};
  padding: 20px;
  gap: 24px;
  overflow-y: auto;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;
`;

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin: 0 -20px -20px;
  padding: 16px 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-top: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
`;
